<template>
	<div class="study">
		<div class="news_header">
			<div class="w1200 flex">
				<router-link to="/" class="header_logo"><img :src="public.bottom_logo" class="block" /></router-link>
				<div class="header_nav f18px">
					<ul>
						<li class="header_nav_list"><router-link to="/" class="cl_white">首页</router-link></li>
						<li class="header_nav_list"><router-link to="/study" class="cl_white">趣学习</router-link></li>
						<li class="header_nav_list"><router-link to="/career" class="cl_white">生涯规划</router-link></li>
						<li class="header_nav_list on"><router-link to="/wish" class="cl_white">志愿填报</router-link></li>
						<li class="header_nav_list"><router-link to="/news_list" class="cl_white">高中资讯</router-link></li>
					</ul>
				</div>
				<div class="news_header_r" v-if="token == null">
					<router-link to="/" class="cl_white f16px">登录</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/logon" class="cl_white f16px">注册</router-link>
				</div>
				<div class="news_header_r" v-else>
					<router-link to="/personal" class="flex cl_white news_header_info">
						<img :src="myInfo.avatar" class="radius mar10" />
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
					</router-link>
				</div>
			</div>
		</div>
		<div class="w1200">
			<div class="major">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/wish" class="cl_gray">志愿填报</router-link>  >  历年录取信息</p>
					</div>
				</div>
			</div>
			<div class="f26px wish_uni_title mat30">{{name}}历年各专业录取信息</div>
			<div class="mat20 f16px">在<span class="cl_red">{{myInfo.province_name}}</span>查询<span class="cl_red">{{yearValue}}</span>年，
			<span class="cl_red">{{science}}</span>，<span class="cl_red">{{level}}</span>录取结果如下:</div>
			<div class="wish_uni_screen flex mat30">
				<div class="flex">
					<div class="flex f16px cl_dark wish_uni_nav">
						<span class="wish_uni_nav_list cur" v-for="(item,index) in year" :key="index" :class="{'on':item==yearValue}" @click="yearCheck(index)">{{item}}</span>
					</div>
					<!-- <p class="cl_gray mal15"> （院校投档分：{{data.num}} 院校投档分位次：{{data.rank}}）</p> -->
				</div>
			</div>
			<div class="wish mat30">
				<div class="wish_cont">
					<table class="choice_table">
						<thead>
							<tr class="f18px">
								<th width="800px">专业名称</th>
								<th width="200px">专业录取最低分</th>
								<th width="200px">专业最低分位次</th>
							</tr>
						</thead>
						<tbody class="f16px cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td align="center"><p>{{item.major_name}}</p></td>
								<td align="center"><p>{{item.min}}</p></td>
								<td align="center"><p>{{item.major_rank}}</p></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
						 :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>找不到内容，请重新选择。</p>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'wish_list',
		components: {
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				token: localStorage.getItem("token"),
				myInfo: {}, //个人信息
				public: {}, //公共部分
				year: [], //年份
				yearValue: "",
				name: "",
				level: "",
				science: "",
				id: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			this.getMyinfo();
			this.getDate();
		},
		created() {
			this.id = this.$route.query.id;
			this.yearValue = this.$route.query.year;
			this.name = this.$route.query.name;
			this.level = this.$route.query.level;
			this.science = this.$route.query.science;
		},
		methods: {
			publicEvent (data) {
				this.public = data;
			},
			//获取用户信息
			getMyinfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
				});
			},
			//年份
			getDate () {
				this.$get("/api/tocollege/get_tocollege_year_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.year = res.data;
					this.getList();
				});
			},
			yearCheck (e) {
				if (this.yearValue = this.year[e]) {
					return false
				}
				this.yearValue = this.year[e];
				this.currentPage = 1;
				this.getList();
			},
			getList () {
				this.$get("/api/tocollege/get_school_major_list",{
					token: localStorage.getItem("token"),
					id: this.id,
					year: this.yearValue,
					level: this.level,
					exam_type: this.science,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
